import Default from "./default";
import Empty from "./empty";

export const Layouts = {
  Main: Default,
  Empty: Empty,
};

export type LayoutKeys = keyof typeof Layouts;
